import(/* webpackMode: "eager" */ "/vercel/path0/src/app/case-study/CaseStudy.tsx")